export const selectLocationsList = (state) => state.locations.locations;
export const selectLocationsLoading = (state) => state.locations.loading;
export const selectLocationsError = (state) => state.locations.error;
export const selectLocationsSuccessMessage = (state) =>
  state.locations.successMessage;
